import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import { transactionsSelectors } from 'app-components/flux/transactions';

type TransactionsById = ReturnType<typeof transactionsSelectors.getResourcesById>;

export type ExcludedFromSpendingPlanDisplayState = {
  value: boolean | null;
  indeterminate: boolean;
};

export const getExcludedFromSpendingPlanDisplayState = (
  txn: Pick<TransactionProps, 'isExcludedFromF2S' | 'split'> | null | undefined,
  transactionsById?: TransactionsById | null,
): ExcludedFromSpendingPlanDisplayState => {
  return transactionsSelectors.getExcludedDisplayState(txn, transactionsById, 'isExcludedFromF2S');
};

export const getExcludedFromReportsDisplayState = (
  txn: Pick<TransactionProps, 'isExcludedFromReports' | 'split'> | null | undefined,
  transactionsById?: TransactionsById | null,
): ExcludedFromSpendingPlanDisplayState => {
  return transactionsSelectors.getExcludedDisplayState(txn, transactionsById, 'isExcludedFromReports');
};
